bz_app.directive('headerNavigation', function () {
  return {
    restrict: 'AE',
    link: function (scope, element, attrs) {
      scope.triggerPropertyNav = function () {
        var addressPosition =
          $('.property-header-address').offset().top -
          $(window).scrollTop() -
          $('header.navbar').height()
        $('.property-header-nav-wrapper').toggleClass(
          'property-header-nav-visible',
          addressPosition <= 0
        )
      }

      scope.init = function () {
        $(window).on('scroll', function () {
          scope.triggerPropertyNav()
        })

        scope.triggerPropertyNav()

        // intercept nav link clicks
        angular.element('#property-header-nav a').click(function (e) {
          var targetSelector = angular.element(this).attr('href')

          if (angular.element(targetSelector).length)
            scope.scrollTo(targetSelector)

          e.preventDefault()
        })
      }

      scope.init()
    },
  }
})
